import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  setCart,
  setTokenInCookie,
  setUserInfo,
  toggleAuthentication,
} from "../../redux/hejalSlice";
import { GoogleLogin } from "@react-oauth/google";
import { Eye, EyeOff } from "lucide-react";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email) {
      setErrEmail("Enter your email");
      return;
    }

    if (!password) {
      setErrPassword("Enter your password");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrEmail("Please enter a valid email address");
      return;
    }

    setIsLoading(true);
    try {
      // API call for login
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.Signin,
        data: { email, password },
      });

      if (response?.errorCode) {
        // Handle errors like incorrect login
        toast.error(response.message || "Login failed, try again!");
        setErrEmail("Invalid email or password");
        setErrPassword("Invalid email or password");
      } else {
        dispatch(toggleAuthentication());

        console.log("cart" , response.data.user.cart)

        if (response?.data?.user?.cart) {
          dispatch(setCart(response?.data.user?.cart));
        }

        dispatch(setUserInfo(response?.data?.user));
        dispatch(
          setTokenInCookie({
            token: response?.data?.token,
            refreshToken: response?.data?.refreshToken,
          })
        );

        const userName = response?.data?.user?.name || "User";
        setSuccessMsg(`Hello, ${userName}, you have successfully logged in!`);
        toast.success("Successfully logged in!");
        navigate("/"); // Adjust to your post-login redirect
      }
    } catch (error) {
      console.log("delete error", error);
      const errorMessage =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogle = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.Google,
        data: {
          googleToken: credentialResponse.credential,
        },
      });

      if (!response.success) {
        toast.error(response.message || "Google login failed");
        return;
      }

      // Check if phone number is null
      if (!response.data.user.phoneNumber) {
        // Store user info in Redux for use in verification page
        dispatch(setUserInfo(response?.data?.user));
        dispatch(
          setTokenInCookie({
            token: response?.data?.token,
            refreshToken: response?.data?.refreshToken,
          })
        );

        // Navigate to phone verification page
        navigate("/userverify", {
          state: {
            from: "google-login",
            userId: response.data.user._id,
          },
        });
        return;
      }

      // If phone number exists, proceed with normal login
      dispatch(setUserInfo(response?.data?.user));
      dispatch(
        setTokenInCookie({
          token: response?.data?.token,
          refreshToken: response?.data?.refreshToken,
        })
      );
      dispatch(toggleAuthentication());

      if (response?.data.user?.cart) {
        dispatch(setCart(response?.data.user?.cart));
      }

      toast.success("Successfully logged in!");
      navigate("/");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Google login failed", {
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen mix-bg-light flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-4xl bg-white shadow-2xl rounded-2xl overflow-hidden grid grid-cols-1 lg:grid-cols-5">
        <div className="lg:col-span-2  hidden bg-[#182134] md:flex flex-col justify-center items-center p-12 text-white">
          {/* <img
            src="https://firebasestorage.googleapis.com/v0/b/savadeshi-vidhyapith.appspot.com/o/Hejal%2FHEJALLOGO.webp?alt=media&token=dc945192-d340-4e52-8709-0a96a3314e93"
            alt="logo"
            className="w-40 mb-8"
          /> */}
         <h1 className="text-2xl font-bold text-white">
                   Luggaelegacy
                  </h1>
          <h2 className="text-3xl font-bold mb-4 text-center">Welcome Back</h2>
          <p className="text-center opacity-80">
            Sign in to continue your Shopping
          </p>
        </div>
        {/* Right Side - SignIn Form */}
        <div className="lg:col-span-3 p-8 md:p-12 flex flex-col justify-center">
          {successMsg ? (
            <div className="text-center space-y-6">
              <p className="text-green-600 text-xl font-semibold">
                {successMsg}
              </p>
              <Link to="/">
                <button className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300">
                  Continue Shopping
                </button>
              </Link>
            </div>
          ) : (
            <form 
            // onSubmit={handleSignIn}
             className="space-y-6">
              <div>
                <h1 className="text-3xl font-bold mb-2 text-gray-800">
                  Sign In
                </h1>
                <p className="text-gray-600">
                  Enter your credentials to access your account
                </p>
              </div>

              {/* Email Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={handleEmail}
                  placeholder="john@workemail.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {errEmail && (
                  <p className="text-red-500 text-sm mt-1 flex items-center">
                    <span className="mr-2">!</span>
                    {errEmail}
                  </p>
                )}
              </div>

              {/* Password Input */}
              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Password
                  </label>
                  <Link
                    to="/forgotpassword"
                    className="text-sm text-blue-600 hover:underline"
                  >
                    Forgot Password?
                  </Link>
                </div>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePassword}
                    placeholder="Enter password"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {errPassword && (
                  <p className="text-red-500 text-sm mt-1 flex items-center">
                    <span className="mr-2">!</span>
                    {errPassword}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              <button
              onClick={handleSignIn}
                disabled={isLoading}
                className={`w-full py-3 rounded-lg text-white font-semibold transition-all duration-300 
                  ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#182134] hover:bg-secondColor"
                  }`}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 mr-3"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>

              {/* Google Login */}
              {/* <div className="flex justify-center">
                <GoogleLogin
                  onSuccess={handleGoogle}
                  onError={(error) => {
                    console.log("Login Failed from google: ", error);
                    toast.error("Google login failed");
                  }}
                  disabled={isLoading}
                />
              </div> */}

              {/* Sign Up Link */}
              <p className="text-center text-sm text-gray-600 mt-4">
                Don't have an account?{" "}
                {/* <Link to="/signup" className="text-blue-600 hover:underline"> */}
                  Sign Up
                {/* </Link> */}
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
